module.exports = __webpack_public_path__ + "static/media/akinalamu.f718c0cb.jpg";